import { thirdPartyService } from "@/services/thirdParty.service";
import { RootState } from "@/vuex/types";
import { ActionTree } from "vuex";
import { ThirdPartyAppState } from "./thirdPartyApp.types";

type ThirdPartyAppActionTree = ActionTree<ThirdPartyAppState, RootState>;

export const actions: ThirdPartyAppActionTree = {
  async loadScopes(context) {
    context.commit("setLoading", true);
    const payload = await thirdPartyService.getScopes();
    context.commit("setScopes", payload);
    context.commit("setLoading", false);
  }
};
